import { Component, OnDestroy, OnInit } from '@angular/core';
import { ArhivskaKnjigaClient, CreateKategorijaMaterijalaCommand, GrupaKategorijaDto, IUpdateKategorijaMaterijalaCommand, UpdateKategorijaMaterijalaCommand } from '@kodit/core/data-api';
import { AlertService, ButtonService, SharedService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormBuilderTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { ArhivskaKnjigaService, KategorijaDokMaterijalaForm } from '../../arhivska-knjiga-service';
import { FormHelper } from '@kodit/core/form-definitions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-kategorije-materijala-form',
  templateUrl: './kategorije-materijala-form.component.html',
  styleUrls: ['./kategorije-materijala-form.component.scss']
})
export class KategorijeMaterijalaFormComponent implements OnInit, OnDestroy {

  form!: any;
  isEditMode = false;

  private _subs: Subscription = new Subscription();

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _dialogConfig: DynamicDialogConfig,
    private _dialogRef: DynamicDialogRef,
    private _client: ArhivskaKnjigaClient,
    private _alertService: AlertService,
    private _btnService: ButtonService,
    private _service: ArhivskaKnjigaService,
    private _formHelper: FormHelper,
    private _sharedService: SharedService

  ) { }

  ngOnInit(): void {
    this.isEditMode = !!this._dialogConfig.data?.id;

    if (this.isEditMode) {
      this.form = this._service.getKategorijaDokMaterijalaEditForm({
        id: this._dialogConfig.data.id,
        naziv: this._dialogConfig.data.naziv,
        rokCuvanja: this._dialogConfig.data.rokCuvanja,
      } as IUpdateKategorijaMaterijalaCommand);
    } else {
      this.form = this._service.getKategorijaDokMaterijalaCreateForm();
    }

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this.save();
      })
    );
  }

  private save() {

    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    this._btnService.disableButton();

    this._sharedService.displayLoadingScreen(true, this.isEditMode ? 'Izmena kategorije' : 'Dodavanje kategorije');

    const request$ = this.isEditMode
      ? this._client.updateKategorijaDokumentarnogMaterijala(this.form.value as UpdateKategorijaMaterijalaCommand)
      : this._client.createKategorijaDokumentarnogMaterijala(this.form.value as CreateKategorijaMaterijalaCommand);

    this._subs.add(
      request$
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          if (res.succeeded) {
            this._alertService.addSuccessMsg(
              res.data
            );
            this._dialogRef.close(true);
          } else {
            this._alertService.addFailedMsg(res.messages?.[0] ?? 'Izmena nije uspela');
          }
        })
      );
  }

  change(dto: GrupaKategorijaDto){
    if (this.isEditMode) {
      return;
    }
    const createForm = this.form as KategorijaDokMaterijalaForm;
    createForm.controls.grupaKategorijaDto.patchValue(dto);
    createForm.controls.grupaKategorijaDto.updateValueAndValidity();
  }

  ngOnDestroy() {
    this._service.resetKategorijaMaterijalaForm();
    this._service.resetKategorijaMaterijalaEditForm();
    this._subs.unsubscribe();
  }
}
